module.exports = __webpack_public_path__ + "img/new12.05807b73.jpg";